import { useEffect } from "react";

export function Logout() {
  useEffect(() => {
    localStorage.clear();
    window.location.href = window.location.origin + "/login";
  }, []);

  return <>Logout...</>;
}
export function Logout2() {
  useEffect(() => {
    localStorage.clear();
    window.location.href = window.location.origin + "/public/prenotazione";
  }, []);

  return <>Logout...</>;
}
